import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { GetListOfBrandSettingCancelToken } from "../../../services/BrandServices";
import {
  GetStatemantTmpList,
  GradeLetterAggregationMethods,
  GradeLetterTemplateDetail,
  GradeLetterTypes,
  getGradeDetails,
  updateGradeSettingDetails,
} from "../../../services/GradeSettingService";
import { handleGradesLocked, handleTableScroll, options } from "../../../utils/commonFunction";
import { isBlockedNumericKey } from "../../common/Helper";
import { RenderAssessmentType } from "../../../utils/CommonGroupingItem";
import PermissionsGate from "../../../utils/permissionGate";
import ListOfTemplateModal from "./ListOfTemplateModal";
import { lockedProgrammes } from "../../../services/CourseService";

const CourseGradeSettingsList = (props) => {
  const history = useHistory()
  const { id } = useParams();
  const [search, setSearch] = useState("");
  const [assessmentList, setAssessmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [aggregationMethodValue, setAggregationMethodValue] = useState();
  const [gradeTypeValue, setGradeTypeValue] = useState();
  const [dropoutValue, setDropoutValue] = useState("");
  const [passMark, setPassMark] = useState("");
  const [passMarkValue, setPassMarkValue] = useState(null);
  const [passMarkMinScore, setPassMarkMinScore] = useState(null);
  const [formulaValue, setFormulaValue] = useState("");
  const [gradeTypeArr, setGradeTypeArr] = useState([]);
  const [aggregationTypeArr, setAggregationTypeArr] = useState([]);
  const [excludeEmptyGrade, setExcludeEmptyGrade] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [selectedTemplateListForCondon, setSelectedTemplateListForCondon] = useState([]);
  const [selectedTemplateListPass, setSelectedTemplateListPass] = useState([]);
  const [sortOrder, setSortOrder] = useState("ASC")
  const [sortKey, setSortKey] = useState("name");
  const [totalRows, setTotalRows] = useState(0)
  const [updateData, setUpdateData] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [editedRows, setEditedRows] = useState([]);
  const [isLock_grade, setIsLock_grade] = useState(0);
  const tooltipObj = {
    aggregationMethodTooltip: "Median of grades - If this is selected, the programme grade must be determined by is the middle value (or the mean of the two middle values) when percentages are arranged in order of value for the courses.\nLowest Grade – If this is selected, the programme grade will be the lowest grade achieved for any of its courses.\nHighest Grade - If this is selected, the programme grade will be the highest grade achieved for any of its courses.\nMode of Grades - If this is selected, the programme grade will be the grade that occurs the most frequently.\nNatural - If this is selected, the programme grade will be the sum of all course grades, scaled by their relative weights.",
    dropoutTootltip: "The number entered will be used to exclude X number of courses which have the lowest final grade from the final calculation, this will only consider courses which have a weight if natural is selected"
  }
  const [brandList, setBrandList] = useState([]);
  const [brandOverride, setBrandOverride] = useState();
  const [sorTemplateList, setSorTemplateList] = useState([]);
  const [allGradesDetails,setAllGradeDetails] = useState([]);
  const [sorTemplatevalue, setsorTemplatevalue] = useState();
  const [switchState, setSwitchState] = useState({
    show_final_results: false,
    show_empty_grades: false,
    allow_student_portal_gradebook_view: false,
    allow_student_portal_sor_to_download: false,
    override_sor_brand: 0,
  });
  const [allowCondonement , setAllowCondonement] = useState(false)
  const [condonementMark , setCondonementMark] = useState(null)
  const [maxScorecondonementMark, setMaxScoreCondonementMark] = useState(null)
  const [linkedProgrammes, setLinkedProgrammes] = useState([]);

  useEffect(() => {
    handleTableScroll()
  }, [loading])

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })

  usePermissionGuardRedirect(['cagsview']);

  useEffect(() => {
    if (props.gradingStandard == 2) {
      history.push("/noaccess")
    }
  }, [props]);

    useEffect(() => {
      if (selectedTemplate?.gradeOptions?.length) {
        const arrCondon = selectedTemplate?.gradeOptions?.map(item => ({
          value: item?.id,
          label: item?.text,
          min_score: item?.min_score,
          max_score: item?.max_score
        })) || []
        const arrPass = selectedTemplate?.gradeOptions?.map(item => ({
          value: item?.id,
          label: item?.text,
          min_score: item?.min_score,
          max_score: item?.max_score,
        })) || []

        // Find and set min_score when passMarkValue exists
        if (passMarkValue) {
          // Find the matching grade option by value/id
          const matchingGradeOption = selectedTemplate?.gradeOptions.find(item => item?.id == passMarkValue)

          if (matchingGradeOption?.min_score !== undefined) {
            setPassMarkMinScore(matchingGradeOption.min_score)
          } else {
            // Handle case where min_score is not found
            setPassMarkMinScore(null) // or some default value
          }
        }

        // Find and set min_score when passMarkValue exists
        if (condonementMark) {
          // Find the matching grade option by value/id
          const matchingGradeOption = selectedTemplate?.gradeOptions.find(item => item?.id == condonementMark)

          if (matchingGradeOption?.max_score !== undefined) {
            setMaxScoreCondonementMark(matchingGradeOption.max_score)
          } else {
            // Handle case where min_score is not found
            setMaxScoreCondonementMark(null) // or some default value
          }
        }
      
      setSelectedTemplateListForCondon(arrCondon)
      setSelectedTemplateListPass(arrPass)
      }
    }, [selectedTemplate])
    
  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        const response = await GetListOfBrandSettingCancelToken(dropdownSource.token);
        if (response?.status == 200) {
          const brands = response.data.brand_setting_list.map(brand => ({
            label: brand.brand_name,
            value: brand.id
          }))
          const sortedBrands = brands.sort((a, b) => {
            if (a.label?.toLowerCase() < b.label?.toLowerCase()) {
              return -1
            } else if (a.label?.toLowerCase() > b.label?.toLowerCase()) {
              return 1
            }
            return 0
          })
          setBrandList(sortedBrands)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    fetchData();

    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, []);

  useEffect(() => {
    const cancelTokenSources = [];

    const getData = async () => {
      setLoading(true);

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      const data = {
        page: 1,
        limit: 10,
        search: '',
        key: 'name',
        sort: 'asc',
        exportStatus: "true",
        viaKeywords: [],
        viaTopics: [],
      };

      try {
        const res = await GetStatemantTmpList(data, source.token);
        if (res.status === 200) {
          const sorTemplates = res.data?.result.map(template => ({
            label: template.name,
            value: template.id
          }))
          const sortedTemplates = sorTemplates.sort((a, b) => {
            if (a.label.toLowerCase() > b.label.toLowerCase()) {
              return -1
            } else if (a.label.toLowerCase() > b.label.toLowerCase()) {
              return 1
            }
            return 0
          })
          setSorTemplateList(sortedTemplates);
        }

        let { data: lockedProgrammeResult } = await lockedProgrammes({
          intake_id: [id],
        });
        setIsDisabled(true);
        if (lockedProgrammeResult.success) {
          setIsDisabled(false);
          setLinkedProgrammes(lockedProgrammeResult);
        }

      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }

    getData();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true)
    let params = {
      page: 1,
      limit: 10,
      key: sortKey,
      sort: sortOrder,
      search: search,
      exportStatus: "true",
      id: id,
    };
    getGradeDetails(params)
      .then((res) => {
        setIsLock_grade(res?.data?.lock_grades?.lock_grades);
        let details = res.data?.data;
        setAllGradeDetails(res.data?.data)
        let assessmentList = res?.data?.assessmentList;
        setsorTemplatevalue(details?.st_template)
        setSwitchState({
          show_final_results: details.show_final_results,
          show_empty_grades: details.show_empty_grades,
          allow_student_portal_gradebook_view: details.allow_student_portal_gradebook_view,
          allow_student_portal_sor_to_download: details.allow_student_portal_sor_to_download,
          override_sor_brand: details.override_sor_brand
        })
        setTotalRows(res?.data?.assessmentList?.length)
        setAssessmentList(assessmentList ? assessmentList : []);
        setBrandOverride(details?.override_brand)
        setAggregationMethodValue(details?.aggregation_method_id);
        setExcludeEmptyGrade(details?.exclude_empty_grades);
        setGradeTypeValue(details?.grading_type);
        setAllowCondonement(details?.allow_condonement);
        setCondonementMark(details?.condonement_mark);
        setFormulaValue(details?.formula);
        if (details?.grading_type == "1" || details?.grading_type == "2") {
          setPassMarkValue(details?.pass_mark)
        } else {
          setPassMark(details?.pass_mark);
        }
        setDropoutValue(details?.drop_lowest_amount == 0 ? "" : details?.drop_lowest_amount);
        if (details?.grading_template_id) {
          GradeLetterTemplateDetail({ id: details?.grading_template_id })
            .then((res) => {
              setSelectedTemplate(res?.data?.list_data[0])
              setEditedRows([])
              setLoading(false)
            }).catch((err) => {
              setLoading(false)
              console.error(err)
            })
        }
        if (!details?.grading_template_id) {
          setLoading(false)
        }
      })
      .catch((err) => {
        console.error("error :", err)
        setLoading(false)
      });

  }, [sortKey, sortOrder, search, updateData]);

  useEffect(() => {
    GradeLetterTypes()
      .then((gradeTypes) => {
        const gradingTypeArr = gradeTypes.data.map(type => ({
          ...type,
          isDisabled: Number(type.value) === 3
        }));
        setGradeTypeArr(gradingTypeArr);
      })
      .catch((err) => console.error(err));
    GradeLetterAggregationMethods()
      .then((aggregationMethods) => {
        setAggregationTypeArr(aggregationMethods?.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleWeightChange = async (e, assId) => {
    const assList = assessmentList
    let value = e.target.value
    if (!value) {
      value = 0
    } else {
      value = +value
    }
    let filteredObj = assList.find(item => item.id === assId);
    if (!filteredObj) {
      return
    }
    let alreadyAdded = editedRows.find(item => filteredObj.id === item.id)
    if (alreadyAdded) {
      alreadyAdded.ass_weighting = value
      await editedRows.splice(editedRows.findIndex(item => item.id == assId), 1)
      editedRows.push(alreadyAdded)
    } else {
      filteredObj.ass_weighting = value
      editedRows.push(filteredObj)
    }
  }

  const handlePassRequiredChange = async (checked, assId, key = "") => {
    const assList = assessmentList
    let filteredObj = assList.find(item => item.id === assId);
    if (!filteredObj) {
      return
    }
    let alreadyAdded = editedRows.find(item => filteredObj.id === item.id)
    let editedState = editedRows;
    if (alreadyAdded) {
      alreadyAdded[key] = checked ? 1 : 0
      await editedState.splice(editedState.findIndex(item => item.id == assId), 1)
      editedState.push(alreadyAdded)
    } else {
      filteredObj[key] = checked ? 1 : 0
      await editedState.push(filteredObj)
    }
    setEditedRows([...editedState])
  }

  const columns = useMemo(() => [
    {
      name: "Item",
      selector: "name",
      sortable: true,
      sortField: "name",
      cell: (row) => {
        return (
          <span title={row.name} className="overflow-ellipsis2 ">
            {row.name ? (
              <Link
                className="as-text-blue curser feature-name"
                to={`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/Details/${row.id}`}
              >
                <span className="textLimit100">{row.name}</span>
              </Link>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      name: "ID",
      selector: "id",
      sortable: true,
      sortField: "id",
      cell: (row) => <p>{row.id && row.id != "" ? row.id : "-"}</p>,
    },
    {
      name: "Type",
      selector: "type",
      sortable: false,
      sortField: "type",
      cell: (row) => (row.type ? RenderAssessmentType(row.type).html : "-"),
    },
    aggregationMethodValue == 6 && {
      name: "Weight",
      selector: "ass_weighting",
      sortable: false,
      cell: (row) => (
        <div className="input_wt02 resultstatus_flex arrowhide">
          <PermissionsGate
            scopes={["cagsedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              className={
                "form-control custom-select-box" + (false ? " is-invalid" : "")
              }
              onKeyDown={(e) => {
                // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                if (isBlockedNumericKey(e.key)) {
                  e.preventDefault();
                }
              }}
              type="number"
              disabled={isLock_grade == 1}
              defaultValue={row.ass_weighting !== null && row.ass_weighting !== undefined  ? row?.ass_weighting : ""} // Set the initial value from the data
              title="Weight"
              onChange={(e) => {
                handleWeightChange(e, row.id)
              }} // Define a function to handle value changes
            />
          </PermissionsGate>
        </div>
      ),
    },
    {
      name: "Maximum Grade",
      selector: "maximumGrade",
      sortable: false,
      sortField: "maximumGrade",
      cell: (row) => (row?.maximumGrade ? row?.maximumGrade : "-"),
    },
    {
      name: "Pass Required",
      selector: "pass_required",
      sortable: false,
      cell: (row) => (
        <div className="custom-control custom-checkbox text-left table-curser" title="Pass Required">
          <PermissionsGate
            scopes={["cagsedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className="custom-control-input"
              id={`pass_required${row.id}`}
              name="pass_required"
              checked={row.pass_required} // Set the initial value from the data
              disabled={isLock_grade == 1}
              onChange={(e) => {
                handlePassRequiredChange(e.target.checked, row.id, "pass_required")
              }} // Define a function to handle value changes
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    aggregationMethodValue != 6 && {
      name: "Exclude from calculation",
      selector: "exclude_from_calculation",
      sortable: false,
      cell: (row) => (
        <div className="custom-control custom-checkbox text-left table-curser" title="Pass Required">
          <PermissionsGate
            scopes={["cagsedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className="custom-control-input"
              id={`exclude_from_calculation${row.id}`}
              name="exclude_from_calculation"
              defaultChecked={row.exclude_from_calculation} // Set the initial value from the data
              disabled={isLock_grade == 1}
              onChange={(e) => {
                handlePassRequiredChange(e.target.checked, row.id, "exclude_from_calculation")
              }} // Define a function to handle value changes
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            {/* <PermissionsGate
              scopes={["castedit"]}
              errorProps={{ disabled: true }}
            > */}
              <Link
                className="mr-1"
                to={`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/Details/${row.id}`}
              >
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              </Link>
            {/* </PermissionsGate> */}
          </div>
        </div>
      ),
    },
  ]);

  const exportData = (fileType, fileName) => {
    let data;
    const header = [
      "Item",
      "ID",
      "Type",
      "Weight",
      "Maximum Grade",
      "Pass Required",
    ];

    let params = {
      page: 1,
      limit: 10,
      key: sortKey,
      sort: sortOrder,
      search: search,
      exportStatus: "true",
      id: id,
    };
    getGradeDetails(params)
      .then((res) => {
        data = res?.data?.assessmentList
        data = data?.map((row) => ({
          ...row,
          "Item": row?.name ? row.name : "-",
          "ID": row.id && row.id != "" ? row.id : "-",
          "Type": row.type ? RenderAssessmentType(row.type).text : "-",
          "Weight": row.ass_weighting !== null && row.ass_weighting !== undefined ? row?.ass_weighting : "-",
          "Maximum Grade": row?.maximumGrade ? row?.maximumGrade : "-",
          "Pass Required": row.pass_required == "1" ? "True" : "False",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

          const blobURL = window.URL.createObjectURL(blob);

          // Create new tag for download file
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          // Remove URL.createObjectURL. The browser should not save the reference to the file.
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
          }, 1000);
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);

          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row["Item"],
              row["ID"],
              row["type"],
              row["Weight"],
              row["Maximum Grade"],
              row["Pass Required"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);

          return false;
        }
      }).catch((err) => console.error(err))

  };

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleUpdateData = () => {
    if (linkedProgrammes?.isLocked) {
      handleGradesLocked(linkedProgrammes.data, "gradeSettings");
      return;
    }

    if (gradeTypeValue === undefined || gradeTypeValue == "5") {
      setErrorMessage("Grade Type is Required")
      return;
    }
    if (aggregationMethodValue === undefined && gradeTypeValue != 3) {
      setErrorMessage("Aggregation Method is Required")
      return;
    }
    if (gradeTypeValue == "2" || gradeTypeValue == "1") {
      if (passMarkValue === "") {
        setErrorMessage("Pass Mark is Required")
        return;
      }
    } else {
      if (passMark == "") {
        setErrorMessage("Pass Mark is Required")
        return;
      }
      if (Number(passMark) > 100 && gradeTypeValue == 0) {
        setErrorMessage("Pass Mark percentage cannot exceed 100%");
        return;
      }
    }
    if (dropoutValue > totalRows - 1 && totalRows > 0 && gradeTypeValue != 3) {
      setErrorMessage("Dropout Value Must Be Smaller Than Total Assessments")
      return;
    }
    if (!selectedTemplate?.id && gradeTypeValue == "2") {
      setErrorMessage("Template is Required")
      return;
    }

    
    if (allowCondonement) {
      if (!condonementMark && condonementMark !== 0) {
        setErrorMessage("Condonement mark is Required")
        return
      }
      const currentPassMark = (gradeTypeValue == "1" || gradeTypeValue == "2") ? passMarkValue : passMark;

      if (gradeTypeValue == "2") {
        if (Number(maxScorecondonementMark) > Number(passMarkMinScore)) {
          setErrorMessage("Condonement mark must be less than pass mark")
          return
        }
      } else if (gradeTypeValue == "3") {
        if (Number(condonementMark) >= Number(passMark)) {
          setErrorMessage("Condonement mark must be less than pass mark")
          return
        }
      } else{
        if (Number(condonementMark) >= Number(currentPassMark)) {
          setErrorMessage("Condonement mark must be less than pass mark")
          return
        }
      }
    }
    setErrorMessage("")
    setIsDisabled(true);
    let data = {
      id,
      ...switchState,
      drop_lowest_amount: dropoutValue ? dropoutValue : 0,
      exclude_empty_grades: excludeEmptyGrade,
      formula: formulaValue,
      grading_method_id: "1",
      grading_template_id: selectedTemplate?.id ? selectedTemplate?.id : 0,
      grading_type: gradeTypeValue,
      pass_mark: gradeTypeValue == "1" || gradeTypeValue == "2" && passMarkValue ? passMarkValue : passMark ? passMark : 0,
      assessment: JSON.stringify(editedRows),
      aggregation_method_id: gradeTypeValue != 3 ? aggregationMethodValue : 1,
      override_brand : null,
      allow_condonement: allowCondonement ? 1 : 0 ,
      condonement_mark : condonementMark,
    };
    if (brandOverride) {
      
      data.override_brand = brandOverride
    }
    if (sorTemplatevalue) {
      data.st_template = sorTemplatevalue
    }else{
      data.st_template = 0
    }
    updateGradeSettingDetails(data)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated Successfully",
        });
        setIsDisabled(false);
        setEditedRows([])
        setUpdateData(!updateData)
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something Went Wrong",
        });
        setUpdateData(!updateData)
        setIsDisabled(false);
        console.error("err: ", err);
      });
  };

  const handleSwitchToggle = (switchName) => {
    setSwitchState((prevState) => ({
      ...prevState,
      [switchName]: !prevState[switchName],
    }));
  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
        <div className="grade-setting-box">
          <div className="course-info-sec">
            {allGradesDetails?.subject_type != "shortcourse" && (allGradesDetails?.qualification == 0 || allGradesDetails?.qualification == null) && <div className="edit-icon new-card-header">
              <div className="card-header">Grade Settings {loading ? <i className="fas fa-cog fa-spin"></i> : ""}</div>
            </div>}
            <div className="card-body-inr card-body-info">
              {allGradesDetails?.subject_type != "shortcourse" && (allGradesDetails?.qualification == 0 || allGradesDetails?.qualification == null) &&  <>
                <div className="edit-icon new-card-header">
              <div className="card-header"> Statement of Results {loading ? <i className="fas fa-cog fa-spin"></i> : ""}</div>
            </div>
            <div className="row mb-3">
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Show Final Results">
                    <label className="mb-0">
                      Show Final Results{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.show_final_results}
                          onChange={() =>
                            handleSwitchToggle("show_final_results")
                          }
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Show Empty Grades">
                    <label className="mb-0">
                      Show Empty Grades{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.show_empty_grades}
                          onChange={() => handleSwitchToggle("show_empty_grades")}
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Allow Student Portal Gradebook View">
                    <label className="mb-0">
                      Allow Student Portal Gradebook View{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.allow_student_portal_gradebook_view}
                          onChange={() =>
                            handleSwitchToggle("allow_student_portal_gradebook_view")
                          }
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Allow Student Portal SOR Download">
                    <label className="mb-0">
                      Allow Student Portal SOR Download{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.allow_student_portal_sor_to_download}
                          onChange={() =>
                            handleSwitchToggle("allow_student_portal_sor_to_download")
                          }
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Override SOR Brand"> 
                    <label className="mb-0">
                      Override SOR Brand{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.override_sor_brand}
                          disabled={isLock_grade == 1}
                          onChange={() =>
                            handleSwitchToggle("override_sor_brand")
                          }
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {
                  switchState.override_sor_brand && switchState.override_sor_brand != null && switchState.override_sor_brand != "0" ? (
                    <div className="col-md-4 col-lg-2">
                  <div
                    className="form-icon-group mb-4 d-block"
                    title="Brand Override"
                  >
                    <label>
                      Brand Override{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (errorMessage?.brandOverride ? " is-invalid" : "")
                      }
                      name="brand_override"
                      value={brandList.filter(function (option) {
                        return option.value == brandOverride;
                      })}
                      onChange={(value) => setBrandOverride(value ? value.value : "")}
                      isClearable
                      options={brandList}
                      maxMenuHeight={175}
                      placeholder={"Brand Override"}
                    />
                  </div>
                </div>
                  ) : null
                }
                
                <div className="col-md-4 col-lg-2">
                  <div
                    className="form-icon-group mb-4 d-block"
                    title="Template"
                  >
                    <label>
                      Template <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (errorMessage?.sorTemplate ? " is-invalid" : "")
                      }
                      name="sor_template"
                      value={sorTemplateList.filter(function (option) {
                        return option.value == sorTemplatevalue;
                      })}
                      onChange={(value) => setsorTemplatevalue(value ? value.value : "")}
                      isClearable
                      options={sorTemplateList}
                      maxMenuHeight={175}
                      placeholder={"Template"}
                    />
                  </div>
                </div>
              </div>
              </>}
            
              <div className="edit-icon new-card-header">
                <div className="card-header">
                  Grading{" "}
                  {loading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
              </div>
              <div className="row grade-store-box ">
                <div className="col-md-4 col-lg-2">
                  <div className="form-icon-group mb-4 d-block" title="Grade Type">
                    <label>
                      Grade Type{" "}
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (false ? " is-invalid" : "")
                      }
                      name="grade_type"
                      value={gradeTypeArr.filter(function (option) {
                        return option.value === gradeTypeValue;
                      })}
                      onChange={(value) => {
                        if (value) {
                          setGradeTypeValue(value.value);
                          setAggregationMethodValue()
                          setDropoutValue("")
                          setPassMarkValue(null)
                          setPassMark("")
                          setSelectedTemplate({})
                          setSelectedTemplateListPass([])
                          if(value.value == 0){
                            setCondonementMark("45")  
                          }else{
                            setCondonementMark("")
                          }
                          if(value.value == 1){
                            setAllowCondonement(false)
                          }
                        } else {
                          setGradeTypeValue();
                          setPassMarkValue(null)
                          setPassMark("")
                          setAggregationMethodValue()
                          setDropoutValue("")
                          setSelectedTemplate({})
                          setSelectedTemplateListPass([])
                          setCondonementMark("");
                        }
                      }}
                      isClearable
                      isDisabled={isLock_grade == 1}
                      options={gradeTypeArr}
                      maxMenuHeight={175}
                      placeholder={"Grade Type"}
                    />
                  </div>
                </div>
                {gradeTypeValue || +gradeTypeValue === 0 ? <>
                  {gradeTypeValue != "3" && (
                    <div className="col-md-4 col-lg-2">
                      <div className="form-icon-group mb-4 d-block" title="Aggregation Method">
                        <label>
                          Aggregation Method{" "}
                          <i className="fal fa-info-circle grade-icon" title={tooltipObj.aggregationMethodTooltip}></i>
                        </label>
                        <Select
                          className={
                            "form-control custom-select-box" +
                            (false ? " is-invalid" : "")
                          }
                          name="aggregation_method"
                          value={aggregationTypeArr.filter(function (option) {
                            return option.value == aggregationMethodValue;
                          })}
                          onChange={(value) => {
                            if (value) {
                              setAggregationMethodValue(value.value);
                            } else {
                              setAggregationMethodValue();
                            }
                          }}
                          isClearable
                          isDisabled={isLock_grade == 1}
                          options={aggregationTypeArr}
                          maxMenuHeight={175}
                          placeholder={"Aggregation Method"}
                        />
                      </div>
                    </div>
                  )}
                  {gradeTypeValue != "3" && (
                    <div className="col-md-4 col-lg-2" title="Dropout Value">
                      <label>
                        Dropout Value{" "}
                        <i className="fal fa-info-circle grade-icon" title={tooltipObj.dropoutTootltip}></i>
                      </label>
                      <div className="form-icon-group mb-4">
                        <input
                          className={
                            "form-control" + (false ? " is-invalid" : "")
                          }
                          type="number"
                          onKeyDown={(e) => {
                            // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                            if (isBlockedNumericKey(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          disabled={isLock_grade == 1}
                          onChange={(e) => {
                            setDropoutValue(e.target.value)
                          }}
                          value={dropoutValue}
                          placeholder="Dropout Value"
                        />
                      </div>
                    </div>
                  )}
                  {gradeTypeValue == "1" ? (
                    <div className="col-md-4 col-lg-2">
                      <div className="form-icon-group mb-4 d-block" title="Pass Mark">
                        <label>
                          Pass Mark{" "}
                        </label>
                        <Select
                          className={
                            "form-control custom-select-box" +
                            (false ? " is-invalid" : "")
                          }
                          name="pass_mark"
                          value={options.filter(option => String(option.value) === String(passMarkValue))}
                          onChange={(value) => {
                            if (value) {
                              setPassMarkValue(value.value);
                            } else {
                              setPassMarkValue(null);
                            }
                          }}
                          isDisabled={isLock_grade == 1}
                          isClearable
                          options={options.filter((_,index) => index != 0)}
                          maxMenuHeight={175}
                          placeholder={"Mark"}
                        />
                      </div>
                    </div>
                  ) : gradeTypeValue == "2" ? (
                    <div className="col-md-4 col-lg-2">
                      <div className="form-icon-group mb-4 d-block" title="Pass Mark">
                        <label>
                          Pass Mark{" "}
                        </label>
                        <Select
                          className={
                            "form-control custom-select-box" +
                            (false ? " is-invalid" : "")
                          }
                          name="pass_mark"
                          value={selectedTemplateListPass?.filter(function (option) {
                            return option.value == passMarkValue;
                          })}
                          onChange={(value) => {
                            if (value) {
                              setPassMarkValue(value.value);
                              setPassMarkMinScore(value.min_score)
                            } else {
                              setPassMarkValue(null);
                            }
                          }}
                          isDisabled={isLock_grade == 1}
                          isClearable
                          options={selectedTemplateListPass}
                          maxMenuHeight={175}
                          placeholder={"Mark"}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-4 col-lg-2" title="Pass Mark">
                      <label>
                        Pass Mark{" "}
                      </label>
                      <div className="form-icon-group mb-4">
                        <input
                          className={
                            "form-control" + (false ? " is-invalid" : "")
                          }
                          type="number"
                          onKeyDown={(e) => {
                            // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                            if (isBlockedNumericKey(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value) {
                              setPassMark(e.target.value)
                            } else {
                              setPassMark("")
                            }
                          }}
                          disabled={isLock_grade == 1}
                          value={passMark}
                          placeholder="Pass Mark"
                        />
                      </div>
                    </div>
                  )}
                  {gradeTypeValue == "2" && (
                    <div className="search-filter-div-right mb-4 mr-2">
                      <label>&nbsp;</label>
                      <div className="filter-search-bar-blk">
                        <div className="add-ticket-blk dropdown-comman">
                          <button
                            data-toggle="modal"
                            data-target="#letterTemplatemodal"
                            className="btn btn-save btn-success"
                            type="button"
                            title="Select Template"
                            disabled={isLock_grade == 1}
                          >
                            <i className="fal fa-file-alt"></i>Select Template
                          </button>
                          {selectedTemplate &&
                            <>
                              {selectedTemplate && selectedTemplate?.name && <div className="d-flex select-delete">
                                <Link
                                  className="as-text-blue curser"
                                  title="Open"
                                  to={`/courseAdministration/gradingTemplate/edit/${selectedTemplate?.id}`}
                                >
                                  <span className="textLimit100">
                                    {selectedTemplate?.name}
                                  </span>
                                </Link>
                                <button
                                  className="btn btn-danger rounded-circle btn-dropdown-item"
                                  title="Delete"
                                  onClick={() => {
                                    setSelectedTemplate({})
                                    setSelectedTemplateListPass([])
                                    setSelectedTemplateListForCondon([])
                                  }}
                                  disabled={isLock_grade == 1}
                                >
                                  <i className="fal fa-trash-alt"></i>
                                </button>
                              </div>}
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </> : ""}
                {gradeTypeValue !== 1 ? <div className="col-md-4 col-lg-2 d-flex ">
                  <label className="mb-0">
                    Allow condonement <i className="fal fa-info-circle" title="Allow condonement"></i>
                  </label>
                  <div className="toggle-switch ml-2">
                    <label className="switch" title="Allow condonement">
                      <input
                        type="checkbox"
                        checked={allowCondonement}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setAllowCondonement(checked);

                          if (checked && gradeTypeValue === 0) {
                            setCondonementMark("45");
                          }

                          if (!checked) {
                            setErrorMessage("");
                            setCondonementMark("");
                          }
                        }}
                        disabled={isLock_grade == 1}
                      />
                      <span className={`slider slider-round ${isLock_grade == 1 ? "icon-disabled" : ""}`}></span>
                    </label>
                  </div>
             
                </div> : null}
                {allowCondonement && (gradeTypeValue != undefined || gradeTypeValue == null) ? (
                    <div className="col-md-4 col-lg-2 " title="Condonement Mark">
                      {gradeTypeValue == "1" ? (
                      
                          <div className="form-icon-group mb-4 d-block" title="Condonement Mark">
                            <label>
                              Condonement Mark{" "}  <i className="fal fa-info-circle grade-icon" ></i>
                            </label>
                            <Select
                              className={
                                "form-control custom-select-box" +
                                (false ? " is-invalid" : "")
                              }
                              name="condonement_mark"
                              value={options.filter(function (option) {
                                return option.value == condonementMark;
                              })}
                              onChange={(value) => {
                                if (value) {
                                  setCondonementMark(value.value);
                                } else {
                                  setCondonementMark("");
                                }
                              }}
                              isClearable
                              options={options}
                              maxMenuHeight={175}
                              placeholder={"Mark"}
                              isDisabled={isLock_grade == 1}
                            />
                          </div>
                     
                      ) : null}
                      {gradeTypeValue == "2" ? (
                         <div className="form-icon-group mb-4 d-block" title="Condonement Mark">
                            <label>
                              Condonement Mark{" "}  <i className="fal fa-info-circle grade-icon"></i>
                            </label>
                        <Select
                          className={
                            "form-control custom-select-box" +
                            (false ? " is-invalid" : "")
                          }
                          name="pass_mark"
                          value={selectedTemplateListForCondon?.filter(function (option) {
                            return option.value == condonementMark;
                          })}
                          onChange={(value) => {
                            if (value) {
                              setMaxScoreCondonementMark(value.max_score)
                              setCondonementMark(value.value);
                            } else {
                              setCondonementMark(null);
                            }
                          }}
                          isDisabled={isLock_grade == 1}
                          isClearable
                          options={selectedTemplateListForCondon}
                          maxMenuHeight={175}
                          placeholder={"Mark"}
                        />
                        </div>
                      ) : null}
                      {(gradeTypeValue == "3" || gradeTypeValue == "0") ? (
                        <div className="form-icon-group mb-4 d-block">
                           <label>
                              Condonement Mark{" "}  <i className="fal fa-info-circle grade-icon"></i>
                            </label>
                          <input
                            className={
                              "form-control" + (false ? " is-invalid" : "")
                            }
                            type="number"
                            onKeyDown={(e) => {
                              // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                              if (isBlockedNumericKey(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              setCondonementMark(e.target.value)
                            }}
                            disabled={isLock_grade == 1}
                            value={condonementMark}
                            placeholder="Condonement Mark"
                          />
                        </div>
                      )
                        : null
                      }

                    </div>

                  ) : null
                }
              </div>
              <hr />
            </div>
          </div>
        </div>
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <div
                      id="assessment-table-main_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter}
                          value={search}
                        />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div
                  className="custom-check custom-control custom-checkbox mt-2 mx-4"
                  title="Exclude empty grades"
                >
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="empty_grade"
                    name="select"
                    disabled={isLock_grade == 1}
                    checked={excludeEmptyGrade}
                    onChange={(e) =>
                      setExcludeEmptyGrade(e.target.checked ? 1 : 0)
                    }
                  />
                  <label className="custom-control-label" htmlFor="empty_grade">
                    Exclude empty grades
                  </label>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={() => setSearch("")}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export spreadsheet"
                      onClick={() => {
                        exportData("xlsx", "Grade Settings List");
                      }}
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export CSV"
                      onClick={() => {
                        exportData("csv", "Grade Settings List");
                      }}
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export PDF"
                      onClick={() => {
                        exportData("pdf", "Grade Settings List");
                      }}
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          data={assessmentList}
          columns={columns.map(item => item)}
          defaultSortField="name"
          progressPending={loading}
          progressComponent={<SkeletonTicketList />}
          defaultSortAsc={true}
          onSort={handleSort}
          highlightOnHover={false}
        />
        <div className="form-group form-group-save-cancel without-pagination-btns">
          <PermissionsGate
            scopes={["cagsedit"]}
            errorProps={{ disabled: true }}
          >
            <button
              className="btn btn-save btn-success"
              type="submit"
              title="Save"
              onClick={handleUpdateData}
              disabled={isDisabled}
            >
              {isDisabled ? (
                <i className="fas fa-cog fa-spin"></i>
              ) : (
                <i className="fal fa-save"></i>
              )}
              Save
            </button>
          </PermissionsGate>
          <button
            className="btn btn-close btn-danger"
            type="button"
            title="Cancel"
            onClick={() => {
              setUpdateData(!updateData)
              setErrorMessage("")
            }}
          >
            <i className="fal fa-times"></i>Cancel
          </button>
          {errorMessage ? <div className="invalid-feedback d-block">
            {errorMessage}
          </div> : ""}
        </div>
      </div>
      <ListOfTemplateModal
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}
      />
    </div>
  );
};

export default CourseGradeSettingsList;
